import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSkeletonLoader,{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"mx-auto",attrs:{"type":_vm.type,"color":"primary"}})
}
var staticRenderFns = []

export { render, staticRenderFns }